import { render, staticRenderFns } from "./Medical3.vue?vue&type=template&id=566d10ae&scoped=true&"
import script from "./Medical3.vue?vue&type=script&lang=js&"
export * from "./Medical3.vue?vue&type=script&lang=js&"
import style0 from "./Medical3.vue?vue&type=style&index=0&id=566d10ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566d10ae",
  null
  
)

export default component.exports